

import {  AAF_MODAL_ERROR, MODAL_TERM_AND_COND } from '../../actions/modal';
import DeviceStorage  from '../../components/DeviceStorage/DeviceStorage';
import UtilsIsLoggedIn from '../../utils/user/isLoggedIn';
import Utils from '../../utils/Utils';
import utilsIsSticky from '../../utils/user/IsSticky';
import store from './../../store';
import UtilsProfile from '../../utils/Profile';
import { fetchProfileRead } from '../../actions/profile';
import { setProfileData } from '../../reducers/profile';
import { createAsyncEvent } from '../../utils/analytics';
import * as constants from '../../AAF/Auth/authConstants';
import {setMetricsEvent} from "../../actions/metrics";
import { apaLegals } from '../../requests/loader';
import Legals from '../../requests/apa/Legals';
import { ISREGISTER } from '../../AAF/Auth/authConstants';
import {REGISTRO,
    TERMINOS_Y_CONDICIONES,
    COMPONENTE_MODAL_TERMINOS_Y_CONDICIONES,
    EXITOSO_CORREO,
    COMPONENTE_REGISTRO
} from '../utils/constansMetrics';
import { getUrlRedirectBack } from 'src/components/Modal/functions/ModalKeepWatching/functions';
import NewRelic from 'src/utils/trackers/NewRelic';
import AAF from 'src/AAF/AAF';

export class RegisterLogic {
  constructor(prop) {
    this.analyticsEvent = createAsyncEvent({
      send: event => {
        this.props.setMetricsEvent(event);
        setMetricsEvent({ type: 'executor' });
      },
      action: constants.REGISTRY_EVENT_ACTION,
      category: constants.REGISTRY_EVENT_CATEGORY,
      successLabel: constants.REGISTRY_EVENT_SUCCESS_LABEL,
      errorLabelPrefix: constants.REGISTRY_EVENT_ERROR_LABEL_PREFIX
    });
    this.props = prop;
  }

  async successRegister(response) {
      const pushSession = Utils.getApaMetadataKey('sticky_session', '{"push_session":false,"user_id":false}', 'push_session');
      if (pushSession) {
        await utilsIsSticky.getPushSessionRegister(response)
        .then(() => {
          this.stickySuccess(response);
          Utils.setCustomAttribute();
          if (response.user_token) {
              DeviceStorage.setItem('user_token', response.user_token);
              AAF.Database.setUserToken(response.user_token);
          }
        })
        .catch(err => {
          const { showModal } = this.props;
          showModal({
            modalType: AAF_MODAL_ERROR,
            modalProps: {
              content: err.response
            }
          });
        });
      }
  }

  async successRegisterIpTelmex(response) {
    this.props.receiveIsLoggedIn(response);
      UtilsIsLoggedIn.setIntervalValidatorTimer();
      const pushSession = Utils.getApaMetadataKey('sticky_session', '{"push_session":false,"user_id":false}', 'push_session');
      if (pushSession) {
        await utilsIsSticky.getPushSessionRegister(response)
        .then(() => {
          DeviceStorage.setItem('user_hash', response.session_userhash);
          if (response.user_id) {
            DeviceStorage.setItem('user_id', response.user_id);
            NewRelic.setUserId(response.user_id);
          }
          if (response.user_token) {
            DeviceStorage.setItem('user_token', response.user_token);
            AAF.Database.setUserToken(response.user_token);
          }
          Utils.setCustomAttribute();
        })
        .catch(err => {
          const { showModal } = this.props;
          showModal({
            modalType: AAF_MODAL_ERROR,
            modalProps: {
              content: err.response
            }
          });
        });
      }
  }

  stickySuccess(response) {
    const {session_userhash = '', user_id = '', user_token = ''} = response;
    DeviceStorage.setItem('user_hash', session_userhash);
    if (user_id) {
      DeviceStorage.setItem('user_id', user_id);
      this.props.fetchLinealChannels(user_id);
      NewRelic.setUserId(user_id);
    }
    if (user_token) {
      DeviceStorage.setItem('user_token', user_token);
      AAF.Database.setUserToken(user_token);
    }
    if (AAF.AdsUtils.isAfterLogin()) {
      this.props.receiveIsLoggedIn(response);
      UtilsIsLoggedIn.setIntervalValidatorTimer();
      Utils.sendMetric(this.props, REGISTRO,  EXITOSO_CORREO , COMPONENTE_REGISTRO);
      setTimeout(() => {
        AAF.AdsUtils.redirectToRootRegister(this.props.history, false);
      }, 2000);
    } else {
      if (this.props && this.props.location && this.props.location.state) {
        this.redirectToCheckout(response);
      } else {
        const { navbar: { nodes } } = store.getState();
        const url = `/node/${nodes[0].code}`;
        const urlRedirect = getUrlRedirectBack(url);
        this.props.history.push({pathname: urlRedirect,showAlert: ISREGISTER})
        this.props.receiveIsLoggedIn(response);
        UtilsIsLoggedIn.setIntervalValidatorTimer();
        Utils.sendMetric(this.props, REGISTRO,  EXITOSO_CORREO , COMPONENTE_REGISTRO);
      }
    }

    this.readProfile(response);
    this.analyticsEvent.success();
  }

  redirectToCheckout(response){

    const {history, history : {location: {state: pbi = false } = {}} = {}} = this.props;

    this.props.receiveIsLoggedIn(response);
    UtilsIsLoggedIn.setIntervalValidatorTimer();
    history.replace(`/detailtransaction`, { ...pbi });
  }

  readProfile(response) {
    const user =  response;
    if (UtilsProfile.isProfileEnable(user)) {
      store.dispatch(fetchProfileRead({}, RegisterLogic.setDefaultProfile, this.showProfileError));
    }
  }

  static setDefaultProfile(response) {
    const members = response.members;
    const defaultProfile = members.find((member) => member.admin === true);

    if (defaultProfile) {
      store.dispatch(setProfileData({
      profile: defaultProfile
      }));
    }
  }

  showProfileError(completeError) {
    const error = completeError && completeError.errors;
    const modal = {
      modalType: AAF_MODAL_ERROR,
      modalProps: {
      callback: () => { },
      content: error,
    }
  };
    this.analyticsEvent.error(error);
    this.props.showModal(modal);
  }

  hiddenAcceptTerm(props){
    Utils.sendMetric(props, REGISTRO,  TERMINOS_Y_CONDICIONES, COMPONENTE_MODAL_TERMINOS_Y_CONDICIONES);
    props.history.push('/register');
  }

  async setLegals(props, callbackWhenBack){
    await  apaLegals()
    .then((result) => {
      const { showModal } = props;
      Legals.setData(result);
      showModal({
        modalType: MODAL_TERM_AND_COND,
        modalProps: {
          callback: (type) => {
            this.hiddenAcceptTerm(props)
          },
          content: '',
          align: 'right',
          callbackWhenBack,
        },
      });
    })
    .catch(err => {
      console.log(err);
    });
  }

}

export default RegisterLogic;



// WEBPACK FOOTER //
// ./src/authentication/Register/RegisterLogic.js